import { InternalAxiosRequestConfig } from 'axios'
import { IRequestMiddleware } from './types'
import environment from '../../config'
import { getToken } from '../../features/auth/services/userService'

export default class AuthorizationMiddleware implements IRequestMiddleware {
  private readonly useAccessToken: boolean
  private readonly useOcpApimKey: boolean

  constructor(useAccessToken: boolean, useOcpApimKey: boolean) {
    this.useAccessToken = useAccessToken
    this.useOcpApimKey = useOcpApimKey
  }

  public async handle(
    requestConfig: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> {
    await this.addAccessTokenToHeaders(requestConfig)
    this.addOcpApimSubscriptionKeyToHeaders(requestConfig)

    return requestConfig
  }

  private async addAccessTokenToHeaders(
    requestConfig: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> {
    if (!this.useAccessToken) return requestConfig

    const token = await getToken()

    if (!token)
      throw new Error(
        'The access token does not exists in current context. Verify the auth flow, we should have a problem.',
      )

    requestConfig.headers['Authorization'] = `Bearer ${token}`

    return requestConfig
  }

  private addOcpApimSubscriptionKeyToHeaders(
    requestConfig: InternalAxiosRequestConfig,
  ): InternalAxiosRequestConfig {
    if (!this.useOcpApimKey) return requestConfig

    requestConfig.headers['Ocp-Apim-Subscription-Key'] = environment.auth.apim.subscriptionKey

    return requestConfig
  }
}
